export class FlashVersion {
  formatVersion(version){
    return version.replace(/\D+/g, ',').match(/^,?(.+),?$/)[1];
  }

  isActiveXObjectSupported(){
    return ((typeof ActiveXObject) !== "undefined");
  }

  getActiveXObject(version){
    var obj = null;
    if(this.isActiveXObjectSupported()){
      obj = new ActiveXObject(version);
    }
    return obj;
  }

  getActiveXObjectVersion(activeXObject){
    return activeXObject.GetVariable("$version");
  }

  flashMimeType(){
    return this.getMimeTypes() && this.getMimeTypes()["application/x-shockwave-flash"];
  }

  flashMimeTypePluginDescription(){
    var flashMimeType = this.flashMimeType();
    if(flashMimeType){
      return flashMimeType.enabledPlugin && flashMimeType.enabledPlugin.description;
    }
  }

  getMimeTypes(){
    return navigator.mimeTypes;
  }

  isHasPlugin(){
    return navigator.plugins && navigator.plugins.length>0;
  }

  triggerAllowScriptAccessFlash6(activeXObject){
    activeXObject.AllowScriptAccess = "always";
  }

  getRawVersionForFlash7(){
    var version, activeXObject;
    try {
      activeXObject = this.getActiveXObject("ShockwaveFlash.ShockwaveFlash.7");
      if(activeXObject){
        version = this.getActiveXObjectVersion(activeXObject);
      }
    }catch(ex){}
    return version;
  }

  getRawVersionForFlash6(){
    var version, activeXObject;
    try {
      activeXObject = this.getActiveXObject("ShockwaveFlash.ShockwaveFlash.6");
      if(activeXObject){
        version = "6,0,0";
        this.triggerAllowScriptAccessFlash6(activeXObject);
        version = this.getActiveXObjectVersion(activeXObject);
      }
    }catch(ex){}
    return version;
  }

  getRawVersionForFlash(){
    var version, activeXObject;
    try {
      activeXObject = this.getActiveXObject("ShockwaveFlash.ShockwaveFlash");
      if(activeXObject){
        version = this.getActiveXObjectVersion(activeXObject);
      }
    }catch(ex){}
    return version;
  }

  getRawVersion(){
    var version;

    if(this.isHasPlugin()){
      version = this.flashMimeTypePluginDescription();
    }

    if(!version){
      version = this.getRawVersionForFlash7() || this.getRawVersionForFlash6() || this.getRawVersionForFlash() || "0,0,0";
    }

    return version;
  }

  get(){
    return this.formatVersion(this.getRawVersion());
  }

}
